import _ from 'lodash';
var t = function t(formatMessage, id) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    values = _ref.values,
    def = _ref.def,
    transformer = _ref.transformer;
  var result = formatMessage({
    id: id,
    defaultMessage: def
  }, values);
  if (typeof transformer === 'function') {
    return transformer(result);
  }
  if (typeof transformer === 'string') {
    return _[transformer](result);
  }
  return result;
};
export default t;